/* eslint-disable react-hooks/exhaustive-deps */
import loading from '@assets/images/loading.svg';
import success from '@assets/images/success.svg';
import { ContactPoint, Path } from '@common/constans';
import { IGResponse, IMessage, IResponse, MessageType } from '@common/models';
import { IContactPoint } from '@common/models/CMS';
import { IPaymentConfirmRequest } from '@common/models/PaymentConfirmRequest';
import Alert from '@components/general/Alert';
import Contact from '@components/general/Contact';
import Icon from '@components/general/Icon';
import { AppAction, IAppAction } from '@misc/Action';
import { CONTACT_POINT, useApolloQuery } from '@service/graphql';
import { Action, confirmPayment } from '@service/proxy';
import Translate from "@service/Translate";
import { onUnload } from '@utilize/Util';
import { FC, useEffect, useState } from 'react';
import { Code } from 'react-content-loader';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from "react-router";

interface IPaymentSuccessProps { }

const PaymentSuccess: FC<IPaymentSuccessProps> = () => {
    const { tr } = Translate;
    const dispatch = useDispatch();
    const { push } = useHistory();
    const query = new URLSearchParams(useLocation().search);
    const { data } = useApolloQuery<IGResponse<IContactPoint[]>>(CONTACT_POINT);
    const [showBookingFailed, setShowBookingFail] = useState<boolean>(false);
    const [traceNumber, setTraceNumber] = useState<string>("");
    const [messages, setMessages] = useState<IMessage[]>([]);
    const ib = data?.contactPoint.find(c => c.code?.code === ContactPoint.IBE);
    const charIndex = ib?.phone?.indexOf("(") || -1;
    const phone = charIndex > -1 ? ib?.phone?.slice(0, charIndex)?.replace(/ /g, "")?.trim() : ib?.phone?.replace(/ /g, "")?.trim();

    useEffect(() => {
        const paymentAction = +(query.get("action") ?? "");
        const code = query.get("code") ?? "";
        const traceNumber = query.get("traceNumber") ?? "";
        setTraceNumber(traceNumber);
        setMessages([]);
        const paymentConfirmRequest: IPaymentConfirmRequest = {
            paymentAction: paymentAction,
            receiptCode: code
        };
        confirmPayment(Action.POST, { data: paymentConfirmRequest })
            .then((response) => {
                const pnrInfo = response.content;
                dispatch<IAppAction>({ type: AppAction.PnrInfo, payload: { pnrInfo } });
                push(`${Path.Booking.Itinerary}?transactionId=${pnrInfo.transactionIdentifier}`);
            })
            .catch((response: IResponse<any>) => {
                if (response?.messages?.length) {
                    setMessages(response.messages);
                }
                else {
                    messages?.push({
                        code: 'rsv_100',
                        type: MessageType.Error
                    })
                    setMessages(messages?.slice())
                }
                setShowBookingFail(true);
            })

        window.addEventListener("beforeunload", onUnload);
        return (() => {
            window.removeEventListener("beforeunload", onUnload);
        })
    }, []);

    return (
        <div className="payment-success">
            <div className="container">
                <div className="row">

                    {
                        showBookingFailed ? <div className="col-1-1 payment-booking-failed">
                            <Icon className='image' name='icon-alert' color='secondary' />
                        </div>
                            : <>
                                <div className="col-1-1 payment-success-loading">
                                    <img className="image" src={loading} alt="Payment Success Loading Icon" />
                                    <span className='desc'>{tr("payment_issuing_ticket")}</span>
                                </div>
                                <div className="col-1-1 payment-success-caption">
                                    <img className="payment-success-img" src={success} alt="Payment Success Icon" />
                                    <div className="payment-success-desc">{tr("payment_msg_successfully")}</div>
                                </div>
                            </>
                    }
                    {
                        messages?.map((message, index) =>
                            <div key={index} className="col-1-1">
                                <Alert
                                    type={MessageType[message.type]?.toLowerCase() as any}
                                    title={message.code ? tr(message.code) : message.text}
                                    variant="none"
                                />
                            </div>
                        )
                    }

                    <div className="col-1-1 payment-trace-number">
                        <span>{tr("trace_number")}: {traceNumber}</span>
                    </div>

                    <div className="col-1-1">
                        <div className="contact-info">{tr("msg_call_support_info")}</div>
                    </div>
                    <div className="col-1-1 flex justify-center">
                        <Contact
                            email={ib?.email || ""}
                            emailText={ib?.email || ""}
                            phone={phone || ""}
                            phoneText={ib?.phone || ""}
                            emailSubject={`Payment success ${Code}`}
                            orientation="horizontal"
                            haveIcon
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentSuccess;